export default "__VITE_ASSET__BxrI2vpp__"